import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Modal from "../../../../components/Modal";
import Form, { Submit, Cancel, Title, InputTextArea } from "../../../../components/Form";

import { availableLanguages, getLocale } from "../../../../../common/parameters";

import messages from "./messages";
import { IProps } from "./interfaces";

const ChangeDescription = ({
    user,
    close,
    submit,
    loading,
    planDescription,
    changeDescription,
}: IProps) => {
    const { formatMessage, locale } = useIntl();
    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    <FormattedMessage {...messages.title} />
                </Title>
                <InputTextArea
                    maxLength={400}
                    label={formatMessage(messages.description)}
                    name={getLocale(locale)}
                    value={planDescription[getLocale(locale)] || ""}
                    onChange={changeDescription}
                    selectAllOnMount
                />
                {user.permission > 1 &&
                    [...availableLanguages, "en"].map(lang => {
                        if (lang === locale) return null;
                        if (lang !== getLocale(lang)) return;
                        return (
                            <InputTextArea
                                key={lang}
                                label={formatMessage(messages.description) + " " + lang.toUpperCase()}
                                value={planDescription[lang] || ""}
                                name={lang}
                                onChange={changeDescription}
                                maxLength={400}
                            />
                        );
                    })}
                <Submit onClick={submit} loading={loading}>
                    <FormattedMessage {...messages.rename} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default ChangeDescription;
